/* Shared motion vocabulary for the public-pages animation kit. One
 * source so Reveal and Stagger (and any future motion component) stay
 * on the same curve and rhythm instead of drifting per-file.
 */

// Same curve as the `out-quint` transitionTimingFunction token in
// tailwind.config.js — keep the two in sync.
export const EASE_OUT_QUINT = [0.22, 1, 0.36, 1];

export const REVEAL_DURATION = 0.55;

// Vertical travel for enter animations. Small on purpose: the reveal
// should read as "settling into place", not "flying in".
export const REVEAL_Y = 16;

// Gap between siblings in a staggered group.
export const STAGGER_INTERVAL = 0.08;
